import { Navigate, Outlet } from "react-router-dom";
import { isPlatformUser, orgRoleRank } from "@/features/auth/roles";
import { type AuthUser, useAuthStore } from "@/features/auth/store/auth-store";

/**
 * Gates the Team roster page. Within the NSI (house) org the full roster —
 * including the Global/Super Admin leadership rows and their access — is visible
 * ONLY to platform admins (GA/SA); a house Country Director and below are bounced
 * to the dashboard. A Business-Practitioner firm's own Country-Director+ keeps the
 * Team page for managing their own firm's members. The server independently
 * scopes every call, so this is a UX guard only.
 */
export function canSeeTeam(user: AuthUser | null): boolean {
  if (!user) return false;
  if (isPlatformUser(user)) return true;
  // A BP firm's own leadership manages its own team; the house org's roster is
  // platform-only (handled above).
  return user.firm?.org_type === "business_practitioner" && orgRoleRank(user) >= 3;
}

export function TeamRoute() {
  const allowed = useAuthStore((s) => canSeeTeam(s.user));
  if (!allowed) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
